/* eslint-disable no-unused-vars */
export enum ContentRecommendationUserAction {
  Dismissed = 1,
  IgnoredByLaunchingGame,
  Timeout,
  CTAClicked,
  IgnoredByChangedInfo,
  OfferDismissed,
  OfferApproved,
  OpenedNotificationSettings,
  TurnedOffPromotions,
}
// -----------------------------------------------------------------------------
